import React from 'react';
import { FaTimes } from 'react-icons/fa';

function UserDropdown({ onClose }) {
  return (
    <div className="user-dropdown">
      <div className="dropdown-header">
        <div className="user-avatar"></div> {/* Placeholder for avatar */}
        <div className="user-info">
          <div className="user-name">Muhammad Usama</div>
          <div className="user-email">usama@oigetit.com</div>
        </div>
        <FaTimes className="close-icon" onClick={onClose} style={{ cursor: 'pointer' }}/>
      </div>
      <div className="dropdown-content">
        <ul>
          <li>User Settings</li>
          <li>Help</li>
          <li>How to use Boolean Search</li>
          <li>Talkwalker Academy</li>
          <li>Status Page</li>
          <li>Contact Us</li>
          <li>Logout</li>
        </ul>
      </div>
    </div>
  );
}

export default UserDropdown; 